import styled from 'styled-components';

const ContentAboutStyle = styled.section`
	--distanceGap: var(--gutter);
	--borderRadius: var(--sp3x);
	--imageSizeStroke1: 68.677%;
	--imageSizeStroke2: 79.275%;
	--sizeImageBottom3: 143.736%;
	--imageSizeStroke3: 69.638%;
	--rightImageSize: 100.373%;
	--rightSectionPadT: var(--sp24x);
	--padTextLR: var(--sp6x);
	--padTextTB: var(--sp9x);
	--distanceTitleDescription: var(--sp4x);

	margin-top: var(--sectionDistance);

	.wrapper-image,
	.mission,
	.vision {
		border-radius: var(--borderRadius);
		border: 1px solid var(--neutral600);
		overflow: hidden;
	}

	.grid-container {
		display: flex;
		flex-direction: column;
		gap: var(--distanceGap);
	}

	.stroke-1,
	.stroke-2,
	.stroke-3 {
		display: grid;
		gap: var(--distanceGap);
	}

	.stroke-1 {
		grid-template-columns: 297fr 563fr 386fr;

		.image-cont {
			--proportion: var(--imageSizeStroke1);
		}
	}

	.stroke-2 {
		grid-template-columns: 816fr 504fr;

		.image-cont {
			--proportion: var(--imageSizeStroke2);
		}
	}

	.stroke-3 {
		grid-template-columns: 476fr 391fr 391fr;

		.wrapper-image {
			height: var(--imageSizeStroke3);

			&.middle-bottom {
				height: 100%;
			}
		}

		.image-cont {
			--proportion: fit-content;
			height: 100%;
		}

		.image-bottom-addHeight {
			--proportion: var(--sizeImageBottom3);
		}
	}

	.right-block {
		margin-top: var(--rightSectionPadT);
		display: flex;
		flex-direction: column;
		gap: var(--distanceGap);

		.wrapper-right-image {
			display: grid;
			grid-template-columns: 396fr 260fr;
		}

		.image-cont {
			--proportion: var(--rightImageSize);
		}
	}

	.mission-vision {
		display: flex;
		flex-direction: column;
		gap: var(--distanceTitleDescription);
		padding: var(--padTextTB) var(--padTextLR);

		.title,
		.description {
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			overflow: hidden;
		}

		.description {
			-webkit-line-clamp: 4;
		}
	}

	.middle {
		.image-cont {
			--proportion: fit-content;
			height: 100%;
		}
	}
	.image-0 {
		transform: translateX(-60%);
	}
	.image-1 {
		transform: translateX(-85%);
	}
	.image-2 {
		transform: translateX(-130%);
	}
	.mission {
		transform: translateX(-80%);
	}
	.image-3 {
		transform: translateY(80%);
	}
	.image-4 {
		transform: translateY(80%);
	}
	.image-5 {
		transform: translateX(80%);
	}
	.vision {
		transform: translateX(80%);
	}
	.image-6 {
		transform: translateX(80%);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceTitleDescription: var(--sp3x);
		--borderRadius: var(--sp3x);
		--padTextLR: var(--sp5x);
		--padTextTB: var(--sp7x);
		--rightSectionPadT: var(--sp19x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceTitleDescription: var(--sp2x);
		--borderRadius: var(--sp2-5x);
		--padTextLR: var(--sp4x);
		--padTextTB: var(--sp6x);
		--borderRadius: var(--sp2-5x);
		--rightSectionPadT: var(--sp16x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--imageSizeStroke1: 70%;
		--imageSizeStroke2: 80%;
		--sizeImageBottom3: 146.41%;
		--distanceTitleDescription: var(--sp3x);
		--padTextLR: var(--sp3x);
		--padTextTB: var(--sp4x);
		--rightSectionPadT: var(--sp13x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--rightSectionPadT: var(--sp17x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--borderRadius: var(--sp1-5x);
		--rightSectionPadT: var(--sp9x);
		--imageSizeStroke1: 71.61%;
		--imageSizeStroke2: 81.73%;
		--sizeImageBottom3: 151.73%;
		--imageSizeStroke3: 68.32%;
		--rightImageSize: 105%;

		--distanceTitleDescription: var(--sp1x);
		--padTextLR: var(--sp1x);
		--padTextTB: var(--sp1x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceGap: var(--sp1-5x);
		--distanceTitleDescription: var(--sp2x);
		--padTextLR: var(--sp2x);
		--padTextTB: var(--sp3x);
		--imageSizeStroke1: 72.06%;
		--imageSizeStroke2: 87.8%;
		--sizeImageBottom3: 151.09%;
		--imageSizeStroke3: 69.3%;

		.stroke-1 {
			grid-template-columns: 563fr 386fr;
		}
		.stroke-2 {
			grid-template-columns: 1fr;
			grid-template-rows: auto 1fr;
		}

		.wrapper-inner-stroke-2 {
			display: grid;
			grid-template-columns: 203fr 169fr;
			gap: var(--distanceGap);
		}

		.empty {
			display: none;
		}
	}
`;
export default ContentAboutStyle;
